import { useSetRecoilState } from "recoil";
import { lookupPricingAtom } from "../miscellaneous/lookupPricingAtom";

export function useSetLookupPricingState() {
    return useSetRecoilState(lookupPricingAtom);
}
